import LogoutIcon from '@mui/icons-material/Logout';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BLACK_COLOR } from '../../../constants/ColorsConst';
import { logoutAction } from '../../../modules/auth/login/LoginAction';
import { rolesArray } from '../../../modules/usuario/usuarios/components/SelectFieldRoles';

const ButtonProfile = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleModalClickOpen = () => {
    setOpen(true);
    setAnchorElUser(null);
  };

  const handleModalClose = () => setOpen(false);

  return (
    <div>
      <Box sx={{ flexGrow: 0 }}>
        <Tooltip title="Perfil">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Stack alignItems="flex-end">
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {loginStore.user.perfil.pnombre}{' '}
                {loginStore.user.perfil.papellido}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                {loginStore.usuEntidad
                  ? 'INVITADO'
                  : loginStore.perfil
                  ? loginStore.perfil.nombre
                  : rolesArray[loginStore.rol].toUpperCase()}
                {loginStore.isAdminTeacher ? ' - ADMIN' : null}
              </Typography>
            </Stack>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
            </IconButton>
          </Stack>
        </Tooltip>
        <Menu
          sx={{ mt: '40px' }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={() => setAnchorElUser(null)}
        >
          {/* <MenuItem onClick={() => { }}>
                        <FaceIcon />
                        <Typography sx={{ ml: 1 }} >Mi Perfil</Typography>
                    </MenuItem> */}
          {/* <MenuItem onClick={() => {
                        history.push(ROUTES.ajustes.to)
                    }}>
                        {ROUTES.ajustes.icon}
                        <Typography sx={{ ml: 1 }} >{ROUTES.ajustes.title}</Typography>
                    </MenuItem> */}
          {/* <Divider sx={{ my: 0.5 }} /> */}
          <MenuItem onClick={handleModalClickOpen}>
            <LogoutIcon />
            <Typography sx={{ ml: 1 }}>Cerrar Sesión</Typography>
          </MenuItem>
        </Menu>
      </Box>
      <Dialog
        open={open}
        onClose={handleModalClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>CERRAR SESIÓN</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            ¿Seguro que quieres salir del sistema?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            onClick={() => {
              handleModalClose();
              logoutAction({ dispatch, history });
            }}
          >
            CONFIRMAR
          </Button>
          <Button sx={{ color: BLACK_COLOR }} onClick={handleModalClose}>
            CANCELAR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ButtonProfile;
